import { DateFactory } from 'rhg-vue-common'
export const parseDate = (date, patterns) => {
  return DateFactory.dateFromPattern(DateFactory.dateObject(date), patterns)
}

export const parseRate = rate => ({
  ...rate,
  nights: rate.nights.map(night => ({
    ...night,
    date: parseDate(night.date)
  })),
  undiscountedRate: rate.undiscountedRate ? parseRate(rate.undiscountedRate) : undefined
})
